



































































































































import Component from "vue-class-component";
import BaseComponent from "../../../components/shared/BaseComponent.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SideModal extends BaseComponent {
  @Prop()
  title!: string;
  @Prop({ default: "md" })
  size!: string;
  @Prop({ default: "px-4 sm:px-6" })
  paddingContent!: string;
  @Prop({ default: "py-6" })
  paddingY!: string;
  created() {
    const self = this;
    document.addEventListener("keyup", evt => {
      if (evt.keyCode === 27) {
        self.close();
      }
    });
  }
  close() {
    this.$emit("close");
  }
}
